import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";

import './style.scss';

import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
    FormInput,
    FormSelect,
    Button
} from "shards-react";
import productList from "../../../images/label/product_list.png";
import viewer from "../../../images/label/viewer.png";
import writer from "../../../images/label/writer.png";
import reviewable_list from "../../../images/label/reviewable_list.png";


const labelData = {
    common: {
        review: "리뷰",
        ratingNum: "평점",
        latest: "최신순",
        recommended: "추천순",
        rating: "평점순",
        helpful: "도움돼요",
        comments: "댓글",
        btnWriteReviewBtn: "리뷰 작성",
        pre: "이전",
        next: "다음",
        close: "닫기",
        btnAttachMedia: "사진/영상 첨부하기",
        submit: "등록",
        rating_1: "최고예요",
        rating_2: "좋아요",
        rating_3: "보통이에요",
        rating_4: "그저 그래요",
        rating_5: "별로예요",
        manager: "관리자",
        orderAt: "주문일",
        photoReview: "포토리뷰",
        allReview: "전체리뷰",
        unitItem: "건",
        purchaseSatisfaction: "구매 만족도",
        aiReviewSummary: "AI 리뷰 요약",
        aiReviewKeyword: "AI 리뷰 키워드",
    },
    productList: {
        title: "REVIEW",
        btnWriteReview: "상품 리뷰 작성하기",
        fixReviewLabel: "쇼핑몰 추천 리뷰",
        writeNotice: "리뷰 작성시 최대 [최대마일리지] 마일리지 적립금 지급",
        info_1: "*** 의 구매자가 이 상품에 만족하고 있어요!",
        info_1_alt: "아직 리뷰가 없어요. 첫 리뷰를 남겨주세요!",
        info_2: "총 *** 건의 후기",
        info_3: "아직 리뷰가 없는 따끈따끈한 상품입니다.",
        titlePhoto: "포토 리뷰",
        reviewWriteDisabled: "리뷰 작성 불가",
        totalRating: "총별점",
        totalCount: "총 건수",
        satisfaction: "만족도",
        itemSatisfaction: "항목별 만족도",
    },
    viewer: {
        title: "포토 리뷰",
        detail: "상세",
        gallery: "갤러리",
        prevReview: "이전 리뷰",
        nextReview: "다음 리뷰",
    },
    writer: {
        title: "리뷰 닫기",
        productSatisfaction: "상품은 만족하셨나요?",
        deliverySatisfaction: "배송은 만족하셨나요?",
        writeLabel: "어떤 점이 좋았나요?",
        writeInfo: "리뷰를 작성해 주세요.(최소 ***자 이상)",
        btnAddMedia: "사진/동영상 첨부하기",
        info_1: "리뷰 작성 시 참고해 주세요",
        info_2: "파일 업로드 성공!",
    },
    reviewableList: {
        info_1: "상품은 어떠셨나요?",
        info_2: "***님의 리뷰를 기다리고 있어요!",
    },
    alert: {
        alreadyReviewed:      "이미 이 상품에 대한 리뷰를 작성하셨습니다.",
        abuseDetected:        "부정행위가 감지되어 활동이 제한됩니다.",
        duplicateReviewExists:"중복된 리뷰가 존재합니다.",
        invalidAccess:        "유효하지 않은 접근입니다.",
        onlyImageAllowed:     "이미지 파일만 업로드할 수 있습니다.",
        reviewWriteFailed:    "리뷰 작성에 실패했습니다. 잠시 후 다시 시도해 주세요.",
        loginRequired:        "로그인 후에 리뷰를 작성할 수 있습니다.",
        noReviewAvailable:    "작성할 수 있는 리뷰가 없습니다.",
        fileSizeExceeded:     "용량이 10MB 이하인 파일만 업로드할 수 있습니다.",
        fileSizeExceeded_1:   "용량이 30MB 이하인 파일만 업로드할 수 있습니다.",
        noReviewYet:          "아직 작성된 리뷰가 없습니다",
        firstReviewPrompt:    "첫 번째 리뷰를 남겨주세요!",
        searchKeywordPrompt:  "리뷰 키워드를 검색해보세요"
    }
}

const labelData_en = {
    common: {
        review: "Review",
        ratingNum: "Rating",
        latest: "Latest",
        recommended: "Recommended",
        rating: "Rating",
        helpful: "Helpful",
        comments: "Comments",
        btnWriteReviewBtn: "Write a Review",
        pre: "Previous",
        next: "Next",
        close: "Close",
        btnAttachMedia: "Attach Photo/Video",
        submit: "Submit",
        rating_1: "Excellent",
        rating_2: "Good",
        rating_3: "Average",
        rating_4: "So-so",
        rating_5: "Poor",
        manager: "manager",
        orderAt: "Order Date",
        photoReview: "Photo Reviews",
        allReview: "All Reviews",
        unitItem: " items",
        purchaseSatisfaction: "Purchase satisfaction",
        aiReviewSummary: "AI review summary",
        aiReviewKeyword: "AI review keywords",
    },
    productList: {
        title: "REVIEW",
        btnWriteReview: "Write a Product Review",
        fixReviewLabel: "Featured Reviews",
        info_1: "*** customers are satisfied with this product!",
        info_1_alt : "There are no reviews yet. Be the first to leave a review!",
        info_2: "Total *** reviews",
        info_3 : "This is a brand-new product with no reviews yet.",
        titlePhoto: "Photo Reviews",
        reviewWriteDisabled: "Review writing disabled",
        totalRating: "Total Rating",
        totalCount: "Total Reviews",
        satisfaction: "Satisfaction",
        itemSatisfaction: "Detailed Ratings",
    },
    viewer: {
        title: "Photo Reviews",
        detail: "Detail",
        gallery: "Gallery",
        prevReview: "Previous Review",
        nextReview: "Next Review",
    },
    writer: {
        title: "Close Review",
        productSatisfaction: "Are you satisfied with the product?",
        deliverySatisfaction: "Was the delivery satisfactory?",
        writeLabel: "What did you like?",
        writeInfo: "Please write a review (at least *** characters)",
        btnAddMedia: "Add Photo/Video",
        info_1: "Please refer to this when writing a review",
        info_2: "File uploaded successfully!",
    },
    reviewableList: {
        info_1: "How was the product?",
        info_2: "***, we're waiting for your review!",
    },
    alert: {
        alreadyReviewed: "You have already written a review for this product.",
        abuseDetected: "Fraudulent activity detected; your actions have been restricted.",
        duplicateReviewExists: "A duplicate review already exists.",
        invalidAccess: "Invalid access.",
        onlyImageAllowed: "Only image files can be uploaded.",
        reviewWriteFailed: "Failed to submit your review. Please try again later.",
        loginRequired: "You must be logged in to write a review.",
        noReviewAvailable: "No reviews available to post.",
        fileSizeExceeded: "You can only upload files up to 10MB.",
        fileSizeExceeded_1: "You can only upload files up to 30MB.",
        noReviewYet: "No reviews have been written yet.",
        firstReviewPrompt: "Be the first to leave a review!",
        searchKeywordPrompt: "Try searching for a review keyword."
    }
}

const labelData_jp = {
    common: {
        review: "レビュー",
        ratingNum: "評価",
        latest: "最新順",
        recommended: "おすすめ順",
        rating: "評価順",
        helpful: "参考になった",
        comments: "コメント",
        btnWriteReviewBtn: "レビューを書く",
        pre: "前へ",
        next: "次へ",
        close: "閉じる",
        btnAttachMedia: "写真・動画を添付する",
        submit: "登録",
        rating_1: "最高です",
        rating_2: "良いです",
        rating_3: "普通です",
        rating_4: "まあまあです",
        rating_5: "よくないです",
        manager: "管理者",
        orderAt: "注文日",
        photoReview: "写真レビュー",
        allReview: "すべてのレビュー",
        unitItem: "件",
        purchaseSatisfaction: "購入満足度",
        aiReviewSummary: "AIレビュー要約",
        aiReviewKeyword: "AIレビューキーワード",
    },
    productList: {
        title: "レビュー",
        btnWriteReview: "商品レビューを書く",
        fixReviewLabel: "おすすめのレビュー",
        info_1: "*** の購入者がこの商品に満足しています！",
        info_1_alt : "まだレビューがありません。最初のレビューを投稿してください！",
        info_2: "レビュー件数：*** 件",
        info_3 : "まだレビューのない、できたてホヤホヤの商品です",
        titlePhoto: "写真レビュー",
        reviewWriteDisabled: "レビュー作成不可",
        totalRating: "総合評価",
        totalCount: "レビュー総数",
        satisfaction: "満足度",
        itemSatisfaction: "項目別満足度",
    },
    viewer: {
        title: "写真レビュー",
        detail: "詳細",
        gallery: "ギャラリー",
        prevReview: "前のレビュー",
        nextReview: "次のレビュー",
    },
    writer: {
        title: "レビューを閉じる",
        productSatisfaction: "商品に満足しましたか？",
        deliverySatisfaction: "配送に満足しましたか？",
        writeLabel: "どんな点が良かったですか？",
        writeInfo: "レビューを記入してください（***文字以上）",
        btnAddMedia: "写真・動画を追加",
        info_1: "レビューを書く際の参考にしてください",
        info_2: "ファイルのアップロードに成功しました！",
    },
    reviewableList: {
        info_1: "商品はいかがでしたか？",
        info_2: "*** さんのレビューをお待ちしています！",
    },
    alert: {
        alreadyReviewed: "この商品に対するレビューは既に投稿済みです。",
        abuseDetected: "不正行為が検出されたため、活動が制限されています。",
        duplicateReviewExists: "重複したレビューが存在します。",
        invalidAccess: "無効なアクセスです。",
        onlyImageAllowed: "画像ファイルのみアップロードできます。",
        reviewWriteFailed: "レビューの投稿に失敗しました。時間をおいて再度お試しください。",
        loginRequired: "レビューを書くにはログインが必要です。",
        noReviewAvailable: "投稿可能なレビューがありません。",
        fileSizeExceeded: "ファイルは10MB以下のみアップロードできます。",
        fileSizeExceeded_1: "ファイルは30MB以下のみアップロードできます。",
        noReviewYet: "まだ作成されたレビューはありません",
        firstReviewPrompt: "最初のレビューを投稿してください！",
        searchKeywordPrompt: "レビューキーワードを検索してください"
    }
}

// https://smartsms.aligo.in/alimapi.html
@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, getDoc: common.getDoc, updateDoc: common.updateDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ booster }) => ({ addKakaoProfile: booster.addKakaoProfile }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))

@observer
class Labeling extends Component {

    // basic
    @observable store = {};
    @observable teamUser = {};
    @observable permissions = {};
    @observable isLogin = false;
    @observable isLoading = false;



    // settings — 기본 프리셋은 한국어. 사용자가 명시적으로 변경하기 전까지 한국어 라벨을 베이스로 표시.
    @observable package = "default_kr";
    @observable initialPackage = "default_kr";  // 패키지 변경 감지용 (저장 시 갱신)
    @observable hasServerLabels = false;
    @observable guideLabelData = {};
    @observable labelData = {};

    // UX 리뉴얼: 탭/검색/필터
    @observable activeTab = 'common'; // 'common' | 'productList' | 'viewer' | 'writer' | 'reviewableList' | 'alert'
    @observable searchKeyword = '';
    @observable showDirtyOnly = false;

    // UX 리뉴얼: 탭 메타
    labelTabs = [
        { key: 'common',         label: '공통 라벨',      icon: 'tag' },
        { key: 'productList',    label: '상품 상세',      icon: 'shopping-bag' },
        { key: 'viewer',         label: '리뷰 보기',      icon: 'eye' },
        { key: 'writer',         label: '리뷰 작성',      icon: 'edit-3' },
        { key: 'reviewableList', label: '작성유도위젯',   icon: 'bell' },
        { key: 'alert',          label: '경고/알림',      icon: 'alert-triangle' }
    ];

    // UX 리뉴얼: 수정 여부 판별 (current vs guide default)
    isFieldDirty = (section, key) => {
        if (!this.labelData[section] || !this.guideLabelData[section]) return false;
        return this.labelData[section][key] !== this.guideLabelData[section][key];
    };

    // UX 리뉴얼: 섹션별 수정 개수
    getDirtyCount = (section) => {
        if (!this.labelData[section] || !this.guideLabelData[section]) return 0;
        return Object.keys(this.labelData[section]).filter(k => this.isFieldDirty(section, k)).length;
    };

    // UX 리뉴얼: 전체 수정 개수
    getTotalDirtyCount = () => {
        let n = 0;
        Object.keys(this.labelData || {}).forEach(sec => { n += this.getDirtyCount(sec); });
        return n;
    };

    // 패키지 변경 여부 (저장 버튼 노출 조건에 함께 사용)
    isPackageDirty = () => this.package !== this.initialPackage;
    hasUnsaved = () => this.getTotalDirtyCount() > 0 || this.isPackageDirty();

    // UX 리뉴얼: 탭 변경
    setTab = (key) => { this.activeTab = key; };

    // UX 리뉴얼: 필드 되돌리기
    revertField = (section, key) => {
        if (this.guideLabelData[section] && key in this.guideLabelData[section]) {
            this.labelData[section][key] = this.guideLabelData[section][key];
        }
    };

    // UX 리뉴얼: 전체 초기화
    resetAll = () => {
        if (!window.confirm('모든 라벨을 기본값으로 초기화하시겠습니까? 저장하지 않은 변경사항이 모두 사라집니다.')) return;
        this.copyCommonData(this.package);
    };

    // 섹션별 표시 여부 — 프리셋 키 + 서버 저장 키 모두 노출하되, 공통 키는 공통 라벨 탭에서만 표시
    shouldShowSectionKey = (section, key) => {
        if (key in labelData.common && !(labelData[section] && key in labelData[section])) return false;
        return true;
    };

    // 섹션 라벨 이름 — 프리셋 라벨이 없으면 key 자체를 표시
    getSectionFieldLabel = (section, key) => {
        return (labelData[section] && labelData[section][key])
            || (labelData.common && labelData.common[key])
            || key;
    };

    // UX 리뉴얼: 검색 매칭 여부
    matchesSearch = (section, key) => {
        const kw = (this.searchKeyword || '').trim().toLowerCase();
        if (!kw) return true;
        const val = (this.labelData[section] && this.labelData[section][key]) || '';
        const guide = (this.guideLabelData[section] && this.guideLabelData[section][key]) || '';
        const sectionLabelMap = labelData[section] || {};
        const label = sectionLabelMap[key] || '';
        return (key.toLowerCase().includes(kw) ||
                String(val).toLowerCase().includes(kw) ||
                String(guide).toLowerCase().includes(kw) ||
                String(label).toLowerCase().includes(kw));
    };


    constructor(props) {
        super(props);
        this.init();
    }

    @action
    init = async () => {
        if (this.props.isLogin) {
            // basic
            this.isLogin = this.props.isLogin;
            this.teamUser = this.props.me;
            this.store = this.props.me.store ? this.props.me.store : {};
            this.permissions = this.props.me.permissions;


            // Load settings - 패키지가 선택되지 않았으면 복사하지 않음
            if (this.package) {
                await this.copyCommonData(this.package);
            }
            await this.getSettings();
            // 초기 패키지 동기화 (변경 감지 기준점)
            this.initialPackage = this.package;

        }
    };

    @action
    copyCommonData = async (selPackage) => {

        let targetLabes;
        switch (selPackage) {
            case "default_kr":
                targetLabes = labelData;
                break;
            case "default_en" :
                targetLabes = labelData_en;
                break;
            case "default_jp":
                targetLabes = labelData_jp;
                break;
            default:
                targetLabes = labelData;
                break;
        }

        const commonData = targetLabes.common;
        Object.keys(targetLabes).forEach(key => {
            if (key !== 'common' && key !== 'alert') {
                this.labelData[key] = _.clone(_.defaults({}, targetLabes[key], commonData));
                this.guideLabelData[key] = _.clone(_.defaults({}, targetLabes[key], commonData));
            }
            else if(key === 'alert') {
                this.labelData.alert = _.clone(targetLabes.alert);
                this.guideLabelData.alert = _.clone(targetLabes.alert);
            }
            else {
                this.labelData.common = _.clone(commonData);
                this.guideLabelData.common = _.clone(commonData);
            }
        });
    };


    @action
    getSettings = async () => {
        let _this = this;
        this.isLoading = true;
        this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
            if(res.labels && res.labels.labels) {
                // 1) 기존 labelData(언어 패키지) 키가 있으면 서버값으로 덮어씀
                Object.entries(_this.labelData).forEach(([key, value]) => {
                    Object.entries(_this.labelData[key] || {}).forEach(([kkey, vvalue]) => {
                        const serverVal = res.labels.labels[key] ? res.labels.labels[key][kkey] : undefined;
                        if (serverVal !== undefined && serverVal !== null) {
                            _this.labelData[key][kkey] = serverVal;
                            if (_this.guideLabelData[key]) {
                                _this.guideLabelData[key][kkey] = serverVal;
                            }
                        }
                    });
                });
                // 2) 언어 패키지가 미선택이어도 서버에 저장된 라벨은 그대로 로드
                Object.entries(res.labels.labels).forEach(([key, section]) => {
                    if (!_this.labelData[key]) _this.labelData[key] = {};
                    if (!_this.guideLabelData[key]) _this.guideLabelData[key] = {};
                    Object.entries(section || {}).forEach(([kkey, vvalue]) => {
                        if (!(kkey in _this.labelData[key])) {
                            _this.labelData[key][kkey] = vvalue;
                            _this.guideLabelData[key][kkey] = vvalue;
                        }
                    });
                });
                _this.hasServerLabels = true;
            }
        })
        this.isLoading = false;
    };

    @action
    saveLables = async () => {
        this.isLoading = true;
        let _this = this;

        const params = {
            store_id: this.teamUser.selStore_id,
            shopNo: this.teamUser.selShopNo || 1,
            labels: this.labelData,
        };

        await this.props.updateDoc('updateLabels', params, (res) => {
            if (res.errors && res.errors.length > 0) {
                toast.error(res.errors[0].message || '저장에 실패했습니다.');
            } else {
                toast.success('라벨 설정이 저장되었습니다.');
                // 저장 후 guideLabelData를 최신으로 동기화하여 dirty 상태 해제
                Object.keys(_this.labelData).forEach(sec => {
                    Object.keys(_this.labelData[sec] || {}).forEach(k => {
                        _this.guideLabelData[sec][k] = _this.labelData[sec][k];
                    });
                });
                // 패키지 변경도 저장된 것으로 간주
                _this.initialPackage = _this.package;
            }
            this.isLoading = false;
        });
    };

    // @action
    // onToggleChange = (section) => {
    //
    // };
    //
    // @action
    // onRadioChange = (event, targetData, valType) => {
    //     const { name, value } = event.target;
    //     targetData[name] = valType === "int" ?  parseInt(value) : value;
    //     console.log(value, name);
    // };

    @action
    onInputChange = (event, target) => {
        const { value, name } = event.target;
        target[name] = value;
    };

    // @action
    // onChangeChecked = async (event, targetObj, keyArray) => {
    //     if(keyArray[0]) {
    //         targetObj[keyArray[0]] = !targetObj[keyArray[0]];
    //     }
    // };

    @action
    onChangeLangSelcter = async (event, targetData) => {
        const { value, name } = event.target;
        // "선택하기" 선택 시: 별도 확인 없이 선택만 반영(라벨 복사 X)
        if (!value) {
            targetData[name] = '';
            return;
        }
        // 프리셋 선택은 미리보기 전용. 라벨을 inputs 에 채워주되, 저장 버튼을 누르기 전까지는 서버에 반영되지 않음.
        targetData[name] = value;
        this.copyCommonData(value);
        toast.info('프리셋이 미리보기로 적용되었습니다. 저장 버튼을 눌러야 서버에 반영됩니다.');
    };



    // @action
    // onChangeStep = async (stepNo) => {
    //     let _this = this;
    // };



    render() {
        return (
            <div className="main-content">
                <PageTitle />
                {(this.isLogin && this.teamUser && !this.teamUser.isPaidShop) && (
                  <div className="es-paywall-banner">
                    <FeatherIcon icon="lock" size="14"/>
                    <span><strong>라벨링 화면은 무료로 확인</strong>할 수 있습니다. 라벨 수정 / 저장은 <strong>유료 플랜 전용</strong>입니다.</span>
                    <button type="button" className="es-paywall-banner__cta"
                            onClick={() => { window.location.href = '/inAppOrder'; }}>
                      <FeatherIcon icon="credit-card" size="13"/>
                      결제페이지로 이동하기
                      <FeatherIcon icon="arrow-right" size="13"/>
                    </button>
                  </div>
                )}
                {( this.isLogin && this.teamUser.emailId ) ? (

                    <div className="write-post-box labeling-setting-box">

                        {/* === A-1: 상단 고정 영역 (언어 + 검색 + 카운터) === */}
                        <div className="lb-topbar">
                            <div className="lb-topbar__lang">
                                <label className="lb-topbar__label">
                                    <FeatherIcon icon="globe" size="14" /> 언어 프리셋
                                </label>
                                <FormSelect name="package"
                                    value={this.package}
                                    onChange={event => {this.onChangeLangSelcter(event, this)}}
                                    className="lb-topbar__select"
                                    title="프리셋 선택은 미리보기 전용입니다. 저장 버튼을 눌러야 서버에 반영됩니다.">
                                    <option value="">선택하기</option>
                                    <option value="default_kr">한국어</option>
                                    <option value="default_jp">일본어</option>
                                    <option value="default_en">영어</option>
                                </FormSelect>
                            </div>
                            <div className="lb-topbar__search">
                                <FeatherIcon icon="search" size="14" className="lb-topbar__search-icon" />
                                <FormInput
                                    placeholder="라벨 검색... (키 또는 값)"
                                    value={this.searchKeyword}
                                    onChange={e => this.searchKeyword = e.target.value}
                                    className="lb-topbar__search-input"
                                />
                                {this.searchKeyword && (
                                    <button type="button" className="lb-topbar__search-clear"
                                            onClick={() => this.searchKeyword = ''}>
                                        <FeatherIcon icon="x" size="14" />
                                    </button>
                                )}
                            </div>
                            <div className="lb-topbar__filter">
                                <label className="lb-dirty-filter">
                                    <input type="checkbox" checked={this.showDirtyOnly}
                                           onChange={e => this.showDirtyOnly = e.target.checked} />
                                    <span>수정된 항목만</span>
                                </label>
                            </div>
                            {this.getTotalDirtyCount() > 0 && (
                                <div className="lb-topbar__counter">
                                    <FeatherIcon icon="edit-2" size="12" />
                                    {this.getTotalDirtyCount()}개 수정됨
                                </div>
                            )}
                        </div>

                        {!this.package && !this.hasServerLabels && (
                            <div style={{padding: '48px 24px', textAlign: 'center', background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 10, marginTop: 16}}>
                                <FeatherIcon icon="globe" size="40" style={{color: '#9CA3AF', marginBottom: 12}}/>
                                <div style={{fontSize: 15, fontWeight: 700, color: '#1F2937', marginBottom: 4}}>언어 프리셋을 선택해 주세요</div>
                                <div style={{fontSize: 13, color: '#6B7280'}}>상단의 <b>언어 프리셋</b>에서 한국어 / 일본어 / 영어 중 하나를 선택하면 라벨을 편집할 수 있습니다.</div>
                            </div>
                        )}

                        {/* === A-2: 카테고리 탭 === */}
                        {(this.package || this.hasServerLabels) && this.labelData.common && (<>
                        <div className="lb-tabs">
                            {this.labelTabs.map(tab => {
                                // 섹션 고유 필드 수 (공통 병합 제외)
                                const count = (labelData[tab.key] && Object.keys(labelData[tab.key]).length) || 0;
                                const dirty = this.getDirtyCount(tab.key);
                                const active = this.activeTab === tab.key;
                                return (
                                    <div key={tab.key}
                                         className={`lb-tabs__item ${active ? 'is-active' : ''} ${dirty > 0 ? 'is-dirty' : ''}`}
                                         onClick={() => this.setTab(tab.key)}>
                                        <FeatherIcon icon={tab.icon} size="14" />
                                        <span className="lb-tabs__label">{tab.label}</span>
                                        <span className="lb-tabs__count">{count}</span>
                                        {dirty > 0 && <span className="lb-tabs__dot" title={`${dirty}개 수정`}></span>}
                                    </div>
                                );
                            })}
                        </div>

                        {/* === A-3: 공통 라벨 (카드 그리드) === */}
                        {this.activeTab === 'common' && (
                        <div className="section-box lb-panel">
                            <div className="section-tit">
                                <h3><FeatherIcon icon="tag" size="18" className="section-icon"/> 공통 라벨</h3>
                                <p className="section-desc">모든 영역에서 공통으로 사용되는 라벨입니다.</p>
                            </div>
                            <div className="label-grid lb-card-grid">
                                {this.guideLabelData.common ? Object.entries(this.guideLabelData.common).map(([key, value], index) => {
                                    if (!this.matchesSearch('common', key)) return null;
                                    const dirty = this.isFieldDirty('common', key);
                                    if (this.showDirtyOnly && !dirty) return null;
                                    return (
                                        <div className={`label-grid-item lb-card ${dirty ? 'is-dirty' : ''}`} key={index}>
                                            <div className="lb-card__head">
                                                <span className="lb-card__key">{key}</span>
                                                {dirty && (
                                                    <button type="button" className="lb-card__revert"
                                                            onClick={() => this.revertField('common', key)}
                                                            title="기본값으로 복원">
                                                        <FeatherIcon icon="rotate-ccw" size="12" />
                                                    </button>
                                                )}
                                            </div>
                                            <label className="label-name">{(labelData.common && labelData.common[key]) || key}</label>
                                            <FormInput
                                                placeholder={value}
                                                name={key}
                                                value={this.labelData.common[key]}
                                                onChange={event => { this.onInputChange(event, this.labelData.common); }}
                                                className={`label-input ${dirty ? 'is-dirty' : ''}`}
                                            />
                                            <div className="lb-card__default">기본값: {value}</div>
                                        </div>
                                    );
                                }) : null}
                            </div>
                        </div>
                        )}

                        {/* === 기본 상품 상세 === */}
                        {this.activeTab === 'productList' && (
                        <div className="section-box lb-panel">
                            <div className="section-tit">
                                <h3><FeatherIcon icon="shopping-bag" size="18" className="section-icon"/> 기본 상품 상세</h3>
                                <p className="section-desc">상품 상세 페이지에 표시되는 라벨입니다.</p>
                            </div>
                            <div className="label-with-preview">
                                <div className="label-edit-area">
                                    <table className="s-table lb-edit-table">
                                        <tbody>
                                        {Object.entries(this.guideLabelData.productList).map(([key, value], index) => {
                                            if (!this.shouldShowSectionKey('productList', key)) return null;
                                            if (!this.matchesSearch('productList', key)) return null;
                                            const dirty = this.isFieldDirty('productList', key);
                                            if (this.showDirtyOnly && !dirty) return null;
                                            return (
                                                <tr key={index} className={dirty ? 'is-dirty' : ''}>
                                                    <th>
                                                        <div className="lb-row-label">{this.getSectionFieldLabel('productList', key)}</div>
                                                        <div className="lb-row-key">{key}</div>
                                                    </th>
                                                    <td>
                                                        <div className="lb-row-edit">
                                                            <FormInput placeholder={value} name={key}
                                                                value={this.labelData.productList[key]}
                                                                onChange={event => this.onInputChange(event, this.labelData.productList)}
                                                                className={dirty ? 'is-dirty' : ''} />
                                                            {dirty && (
                                                                <button type="button" className="lb-row-revert"
                                                                    onClick={() => this.revertField('productList', key)}
                                                                    title="되돌리기">
                                                                    <FeatherIcon icon="rotate-ccw" size="13" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="label-preview-area lb-sticky-preview">
                                    <div className="preview-header"><FeatherIcon icon="monitor" size="14" className="preview-icon"/> 미리보기</div>
                                    <img src={productList} alt="기본 상품 상세 미리보기" />
                                </div>
                            </div>
                        </div>
                        )}

                        {/* === 리뷰 보기 === */}
                        {this.activeTab === 'viewer' && (
                        <div className="section-box lb-panel">
                            <div className="section-tit">
                                <h3><FeatherIcon icon="eye" size="18" className="section-icon"/> 리뷰 보기</h3>
                                <p className="section-desc">리뷰 상세 보기 화면에 표시되는 라벨입니다.</p>
                            </div>
                            <div className="label-with-preview">
                                <div className="label-edit-area">
                                    <table className="s-table lb-edit-table">
                                        <tbody>
                                        {Object.entries(this.guideLabelData.viewer).map(([key, value], index) => {
                                            if (!this.shouldShowSectionKey('viewer', key)) return null;
                                            if (!this.matchesSearch('viewer', key)) return null;
                                            const dirty = this.isFieldDirty('viewer', key);
                                            if (this.showDirtyOnly && !dirty) return null;
                                            return (
                                                <tr key={index} className={dirty ? 'is-dirty' : ''}>
                                                    <th>
                                                        <div className="lb-row-label">{this.getSectionFieldLabel('viewer', key)}</div>
                                                        <div className="lb-row-key">{key}</div>
                                                    </th>
                                                    <td>
                                                        <div className="lb-row-edit">
                                                            <FormInput placeholder={value} name={key}
                                                                value={this.labelData.viewer[key]}
                                                                onChange={event => this.onInputChange(event, this.labelData.viewer)}
                                                                className={dirty ? 'is-dirty' : ''} />
                                                            {dirty && (
                                                                <button type="button" className="lb-row-revert"
                                                                    onClick={() => this.revertField('viewer', key)}
                                                                    title="되돌리기">
                                                                    <FeatherIcon icon="rotate-ccw" size="13" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="label-preview-area lb-sticky-preview">
                                    <div className="preview-header"><FeatherIcon icon="monitor" size="14" className="preview-icon"/> 미리보기</div>
                                    <img src={viewer} alt="리뷰 보기 미리보기" />
                                </div>
                            </div>
                        </div>
                        )}

                        {/* === 리뷰 작성 === */}
                        {this.activeTab === 'writer' && (
                        <div className="section-box lb-panel">
                            <div className="section-tit">
                                <h3><FeatherIcon icon="edit-3" size="18" className="section-icon"/> 리뷰 작성</h3>
                                <p className="section-desc">리뷰 작성 폼에 표시되는 라벨입니다.</p>
                            </div>
                            <div className="label-with-preview">
                                <div className="label-edit-area">
                                    <table className="s-table lb-edit-table">
                                        <tbody>
                                        {Object.entries(this.guideLabelData.writer).map(([key, value], index) => {
                                            if (!this.shouldShowSectionKey('writer', key)) return null;
                                            if (!this.matchesSearch('writer', key)) return null;
                                            const dirty = this.isFieldDirty('writer', key);
                                            if (this.showDirtyOnly && !dirty) return null;
                                            return (
                                                <tr key={index} className={dirty ? 'is-dirty' : ''}>
                                                    <th>
                                                        <div className="lb-row-label">{this.getSectionFieldLabel('writer', key)}</div>
                                                        <div className="lb-row-key">{key}</div>
                                                    </th>
                                                    <td>
                                                        <div className="lb-row-edit">
                                                            <FormInput placeholder={value} name={key}
                                                                value={this.labelData.writer[key]}
                                                                onChange={event => this.onInputChange(event, this.labelData.writer)}
                                                                className={dirty ? 'is-dirty' : ''} />
                                                            {dirty && (
                                                                <button type="button" className="lb-row-revert"
                                                                    onClick={() => this.revertField('writer', key)}
                                                                    title="되돌리기">
                                                                    <FeatherIcon icon="rotate-ccw" size="13" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="label-preview-area lb-sticky-preview">
                                    <div className="preview-header"><FeatherIcon icon="monitor" size="14" className="preview-icon"/> 미리보기</div>
                                    <img src={writer} alt="리뷰 작성 미리보기" />
                                </div>
                            </div>
                        </div>
                        )}

                        {/* === 작성유도위젯 === */}
                        {this.activeTab === 'reviewableList' && (
                        <div className="section-box lb-panel">
                            <div className="section-tit">
                                <h3><FeatherIcon icon="bell" size="18" className="section-icon"/> 작성유도위젯</h3>
                                <p className="section-desc">리뷰 작성 유도 위젯에 표시되는 라벨입니다.</p>
                            </div>
                            <div className="label-with-preview">
                                <div className="label-edit-area">
                                    <table className="s-table lb-edit-table">
                                        <tbody>
                                        {Object.entries(this.guideLabelData.reviewableList).map(([key, value], index) => {
                                            if (!this.shouldShowSectionKey('reviewableList', key)) return null;
                                            if (!this.matchesSearch('reviewableList', key)) return null;
                                            const dirty = this.isFieldDirty('reviewableList', key);
                                            if (this.showDirtyOnly && !dirty) return null;
                                            return (
                                                <tr key={index} className={dirty ? 'is-dirty' : ''}>
                                                    <th>
                                                        <div className="lb-row-label">{this.getSectionFieldLabel('reviewableList', key)}</div>
                                                        <div className="lb-row-key">{key}</div>
                                                    </th>
                                                    <td>
                                                        <div className="lb-row-edit">
                                                            <FormInput placeholder={value} name={key}
                                                                value={this.labelData.reviewableList[key]}
                                                                onChange={event => this.onInputChange(event, this.labelData.reviewableList)}
                                                                className={dirty ? 'is-dirty' : ''} />
                                                            {dirty && (
                                                                <button type="button" className="lb-row-revert"
                                                                    onClick={() => this.revertField('reviewableList', key)}
                                                                    title="되돌리기">
                                                                    <FeatherIcon icon="rotate-ccw" size="13" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="label-preview-area lb-sticky-preview">
                                    <div className="preview-header"><FeatherIcon icon="monitor" size="14" className="preview-icon"/> 미리보기</div>
                                    <img src={reviewable_list} alt="작성유도위젯 미리보기" />
                                </div>
                            </div>
                        </div>
                        )}

                        {/* === 경고/알림 메시지 === */}
                        {this.activeTab === 'alert' && (
                        <div className="section-box lb-panel">
                            <div className="section-tit">
                                <h3><FeatherIcon icon="alert-triangle" size="18" className="section-icon"/> 경고/알림 메시지</h3>
                                <p className="section-desc">사용자에게 표시되는 경고 및 알림 메시지입니다.</p>
                            </div>
                            <table className="s-table lb-edit-table">
                                <tbody>
                                {this.guideLabelData.alert && this.labelData.alert ? Object.entries(this.guideLabelData.alert).map(([key, value], index) => {
                                    if (!this.matchesSearch('alert', key)) return null;
                                    const dirty = this.isFieldDirty('alert', key);
                                    if (this.showDirtyOnly && !dirty) return null;
                                    return (
                                        <tr key={index} className={dirty ? 'is-dirty' : ''}>
                                            <th>
                                                <div className="lb-row-label">{(labelData.alert && labelData.alert[key]) || key}</div>
                                                <div className="lb-row-key">{key}</div>
                                            </th>
                                            <td>
                                                <div className="lb-row-edit">
                                                    <FormInput placeholder={value} name={key}
                                                        value={this.labelData.alert[key]}
                                                        onChange={event => this.onInputChange(event, this.labelData.alert)}
                                                        className={dirty ? 'is-dirty' : ''} />
                                                    {dirty && (
                                                        <button type="button" className="lb-row-revert"
                                                            onClick={() => this.revertField('alert', key)}
                                                            title="되돌리기">
                                                            <FeatherIcon icon="rotate-ccw" size="13" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }) : null}
                                </tbody>
                            </table>
                        </div>
                        )}

                        {/* === Sticky 저장 바 (컨텐츠 내부, wbp-sticky-save 패턴) === */}
                        {this.hasUnsaved() && (
                          <div className="wbp-sticky-save wbp-sticky-save--top">
                            <div className="wbp-sticky-save__msg">
                              {this.getTotalDirtyCount() > 0 ? (
                                <>
                                  <FeatherIcon icon="alert-circle" size="16" />
                                  <strong>{this.getTotalDirtyCount()}개 항목</strong>이 수정되었습니다.
                                  {this.isPackageDirty() && (
                                    <span className="wbp-sticky-save__tags">
                                      <span className="wbp-sticky-save__tag">언어 프리셋 변경</span>
                                    </span>
                                  )}
                                </>
                              ) : (
                                <>
                                  <FeatherIcon icon="globe" size="16" />
                                  <strong>언어 프리셋</strong>이 변경되었습니다.
                                </>
                              )}
                            </div>
                            <div className="wbp-sticky-save__actions">
                              <Button theme="light" size="sm" onClick={() => this.resetAll()}>
                                <FeatherIcon icon="rotate-ccw" size="13" /> 모두 되돌리기
                              </Button>
                              <Button theme="primary" size="sm" onClick={() => this.saveLables()}>
                                <FeatherIcon icon="save" size="13" /> 저장 {this.getTotalDirtyCount() > 0 ? `(${this.getTotalDirtyCount()})` : ''}
                              </Button>
                            </div>
                          </div>
                        )}
                        </>)}

                    </div>
                    ) :
                    null
                }

                <ModalLoading isLoading={this.isLoading} />
            </div>
        );
    }
}

export default Labeling;